import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17d43a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search_wrap mt-4 p-2" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "columns is-mobile is-multiline p-4" }
const _hoisted_4 = { class: "item_wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "img_wrap" }
const _hoisted_7 = { class: "is-hidden-mobile desk" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "cont" }
const _hoisted_10 = { class: "mobile is-hidden-tablet" }
const _hoisted_11 = { class: "img_wrap" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "t1" }
const _hoisted_14 = { class: "c1" }
const _hoisted_15 = { class: "f1" }
const _hoisted_16 = { class: "ml-2 has-text-info" }
const _hoisted_17 = { class: "ml-2 has-text-grey" }
const _hoisted_18 = { class: "ml-2" }
const _hoisted_19 = { class: "not_mobile is-hidden-mobile" }
const _hoisted_20 = { class: "t1" }
const _hoisted_21 = { class: "c1" }
const _hoisted_22 = { class: "f1" }
const _hoisted_23 = { class: "ml-2 has-text-info" }
const _hoisted_24 = { class: "ml-2 has-text-grey" }
const _hoisted_25 = { class: "ml-2" }
const _hoisted_26 = {
  key: 0,
  class: "blankBoard"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txtwrap" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "is-size-5 has-text-grey" }, "조건에 맞는 문서가 없습니다.")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "is-size-6 has-text-grey" }, "검색어 및 권한을 확인 하세요.")
  ])
], -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "footer_wrap" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen" })
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "write")
], -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search_val) = $event)),
          onKeypress: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search_go && _ctx.search_go(...args)), ["enter"])),
          class: "input",
          type: "text",
          placeholder: "찿을 문서의 검색어를 입력하세요."
        }, null, 544), [
          [_vModelText, _ctx.search_val]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.board_list, (d) => {
        return (_openBlock(), _createElementBlock("div", {
          key: d.url_key,
          class: "column is-full-mobile is-full-tablet is-full-desktop is-half-widescreen is-half-fullhd"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "item box is-clickable is-unselectable",
              onClick: ($event: any) => (_ctx.clickGoToView(d.url_key))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "img",
                    src: _ctx.getImg(d.main_img)
                  }, null, 8, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      class: "img",
                      src: _ctx.getImg(d.main_img)
                    }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(d.title), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(d.sub_title), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getOpenTypeText(d.open_type)), 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(d.write_date_text), 1),
                    _createElementVNode("span", _hoisted_18, "by " + _toDisplayString(d.writer), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("a", null, _toDisplayString(d.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(d.sub_title), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.getOpenTypeText(d.open_type)), 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(d.write_date_text), 1),
                    _createElementVNode("span", _hoisted_25, "by " + _toDisplayString(d.writer), 1)
                  ])
                ])
              ])
            ], 8, _hoisted_5)
          ])
        ]))
      }), 128))
    ]),
    ((_ctx.board_list.length == 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
      : _createCommentVNode("", true),
    (!_ctx.is_last_doc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickMoreList && _ctx.clickMoreList(...args)))
          }, "더보기")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_30, [
      (_ctx.is_writer)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn_wrap",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickWriteGo && _ctx.clickWriteGo(...args)))
          }, _hoisted_33))
        : _createCommentVNode("", true)
    ])
  ]))
}